export const downloadQRCodeAsPNG = (
  elementId,
  fileName = "QR-Code.png",
  size = 200
) => {
  const svg = document.getElementById(elementId);
  if (!svg) return;

  // Convert SVG to string
  const svgData = new XMLSerializer().serializeToString(svg);
  const svgBlob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
  const svgUrl = URL.createObjectURL(svgBlob);

  // Create canvas and image
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  const img = new Image();

  img.onload = () => {
    // Set canvas dimensions to match QR code size
    canvas.width = size;
    canvas.height = size;

    // Draw white background
    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Draw the image
    ctx.drawImage(img, 0, 0, size, size);

    // Get dataURL and trigger download
    const dataUrl = canvas.toDataURL("image/png");
    let aEl = document.createElement("a");
    aEl.href = dataUrl;
    aEl.download = fileName;
    document.body.appendChild(aEl);
    aEl.click();
    document.body.removeChild(aEl);

    // Clean up
    URL.revokeObjectURL(svgUrl);
  };

  img.src = svgUrl;
};
